import { createSelector } from '@ngrx/store';
import { NotificationsState } from '../reducers/notifications.reducer';
import { selectNotificationsState } from '../index';

export const getNotificationList = createSelector(
  selectNotificationsState,
  (state: NotificationsState) => state.notifications
);

export const getNextPageUrl = createSelector(
  selectNotificationsState,
  (state: NotificationsState) => state.nextPageUrl
);

export const getPreviousPageUrl = createSelector(
  selectNotificationsState,
  (state: NotificationsState) => state.prevPageUrl
);

export const getTotalCount = createSelector(selectNotificationsState, (state: NotificationsState) => state.totalCount);

export const getFilter = createSelector(selectNotificationsState, (state: NotificationsState) => state.filter);

export const getSearchQuery = createSelector(
  selectNotificationsState,
  (state: NotificationsState) => state.searchQuery
);

export const getNotificationPreferences = createSelector(
  selectNotificationsState,
  (state: NotificationsState) => state.preferences
);
